"use client";

import type { FC, Ref } from "react";
import { Flex, Grid, Separate, Text, type ClassNameProp } from "@huub-web/ui";

import type { FAQItemRecord } from "../../types";
import { FAQListItem } from "../FAQListItem/FAQListItem";

import {
  gridStyle,
  listStyle,
  titleContainerStyle,
  titleStyle,
} from "./FAQList.css";

export type FAQListProps = ClassNameProp & {
  title: string;
  items: FAQItemRecord[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * FAQList component displays a list of frequently asked questions.
 */
export const FAQList: FC<FAQListProps> = ({ title, items = [], ref }) => (
  <Flex ref={ref}>
    <Grid className={gridStyle}>
      <div className={titleContainerStyle}>
        <Text as="h2" variant="displayL" bold className={titleStyle}>
          {title}
        </Text>
      </div>
      <Flex as="ul" direction="column" className={listStyle}>
        <Separate>
          {items.map((item, i) => (
            <FAQListItem key={i} record={item} />
          ))}
        </Separate>
      </Flex>
    </Grid>
  </Flex>
);
